import Image from "next/image"
import React from "react"
import ClientCarousel from "./home/client-carousel"
type Props = {
  path: any
  alt: string
  title: string
  width: number
  height: number
  pageTitle: string
  desc?: string
  className: string
  isButton?: boolean
  isDesc?: boolean
  children?: any
}
const DedicatedHero: React.FC<Props> = ({
  path,
  alt,
  title,
  width,
  height,
  pageTitle,
  isDesc,
  desc,
  className,
  isButton,
  children,
}) => {
  return (
    <section className={`hero technology-herosection ${className}`}>
      <div className="container lg:container md:mx-auto top-hero">
        <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
          <div className="w-full">
            <div className="inline-flex flex-col lg:items-start gap-4 hero-content justify-center h-full">
              <h1 className="mb-0 dark:text-textcolor">{pageTitle}</h1>
              {isDesc ? (
                <p className="mb-0 font-semibold text-secondary dark:text-secondary">
                  {desc}
                </p>
              ) : (
                <></>
              )}

              {children}
              {isButton ? (
                <>
                  <button
                    className="btn btn-primary self-baseline"
                     aria-labelledby="scheduleInterviewLabel"
                    onClick={() => {
                      window.open(
                        "https://api.whatsapp.com/send/?phone=918469699995&text=Hi",
                      )
                    }}
                  >
                    Schedule Interview
                  </button>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="text-center lg:text-end lg:self-center">
            <div className="md:block">
              <Image
                src={`/img/technology/img-hero-${path}@2x.webp`}
                width={width}
                height={height}
                alt={alt}
                title={title}
                className="max-w-[100%]"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      <ClientCarousel />
    </section>
  )
}

export default DedicatedHero
